import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { RACE_ID_KEY } from '@portal/common/models/data-key';

import _ from '../../locale';
import { getEntityHierarchies } from '../../store/data-explorer/selectors';
import ChartHierarchicalDropdown from '../ChartHierarchicalDropdown';

type Props = React.ComponentPropsWithoutRef<typeof ChartHierarchicalDropdown>;

const optionLabelGetter = (o) => o.label;
const optionValueGetter = (o) => o.value;

const RaceDropdown = (props: Props) => {
    const entityHierarchies = useSelector(getEntityHierarchies);

    const loadHierarchy = useCallback(
        () => Promise.resolve(entityHierarchies.races),
        [entityHierarchies.races]
    );

    return (
        <ChartHierarchicalDropdown
            {...props}
            filterKey={RACE_ID_KEY}
            placeholder={_('search_race_id')}
            useLetterPrefix={false}
            loadHierarchy={loadHierarchy}
            optionLabelGetter={optionLabelGetter}
            optionValueGetter={optionValueGetter}
        />
    );
};

export default RaceDropdown;
